module.exports = __webpack_public_path__ + "fonts/Gilroy-Thin.e1358f50.woff";